import { AnyAction } from 'redux'

import { SET_PDF_DATA, CLEAR_PDF_DATA } from '@actions/editPDF'

import { PDFData } from '@types'

const initialPDFDataState: PDFData | null = null

export const editPDF = (state = initialPDFDataState, action: AnyAction) => {
  switch (action.type) {
    case SET_PDF_DATA:
      return action.pdfData
    case CLEAR_PDF_DATA:
      return null
    default:
      return state
  }
}
